module.exports = __webpack_public_path__ + "media/components/client_connexion/static/riingLogo-4c3175a0dac56a42d9daae7ef715b51c.png";